/**
 * @generated SignedSource<<d63f2b58d6c8f222e9d394e74df143a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewNftList_contractImport$data = {
  readonly id: string;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftTile_nftItem">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "NftProfileImportCollectionViewNftList_contractImport";
};
export type NftProfileImportCollectionViewNftList_contractImport$key = {
  readonly " $data"?: NftProfileImportCollectionViewNftList_contractImport$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftList_contractImport">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "items"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": [
        "NFT_ITEM_IMPORT_STATUS_COMPLETE",
        "NFT_ITEM_IMPORT_STATUS_PROCESSING"
      ],
      "kind": "LocalArgument",
      "name": "importStatuses"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ListPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "NftProfileImportCollectionViewNftList_contractImport",
  "selections": [
    {
      "alias": "items",
      "args": [
        {
          "kind": "Variable",
          "name": "importStatuses",
          "variableName": "importStatuses"
        }
      ],
      "concreteType": "NftTokenContractImportCreatedItemsConnection",
      "kind": "LinkedField",
      "name": "__NftProfileImportCollectionViewNftList_items_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftTokenContractImportCreatedItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftProfileImportCollectionViewNftTile_nftItem"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "NftTokenContractImport",
  "abstractKey": null
};
})();

(node as any).hash = "bcb55bd61330e8d2039017a687547c72";

export default node;
